import moment from 'moment';

export const dayDifference = (startDate: any, endDate: any) => {
  const start = new Date(moment(startDate).format('MM/DD/YYYY'));
  const end = new Date(moment(endDate).format('MM/DD/YYYY'));
  const diffDays = Math.floor(
    (Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()) -
      Date.UTC(start.getFullYear(), start.getMonth(), start.getDate())) /
      (1000 * 60 * 60 * 24),
  );
  return diffDays;
};

export const timeDifference = (from: any, to: any) => {
  const fromTime = moment(from, 'hh:mm');
  const toTime = moment(to, 'hh:mm');
  const ms = toTime.diff(fromTime);
  const d = moment.duration(ms);
  const minute = Math.floor(ms / 60000);
  let seconds = ms / 1000;
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;
  if (hours === 0) {
    return `${minutes}m`;
  }
  if (minutes === 0) {
    return `${hours}h`;
  }
  if (hours !== 0 && minutes !== 0) {
    return `${hours}h ${minutes}m`;
  }
};

export const convertTime12to24 = (time12h: any) => {
  const [time, modifier] = time12h?.split(' ');
  let [hours, minutes] = time?.split(':');
  if (hours === '12') {
    hours = '00';
  }
  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}`;
};
export const convertTime12to24WithSec = (time12h: any) => {
  const [time, modifier] = time12h.split(' ');
  let [hours, minutes] = time.split(':');
  if (hours === '12') {
    hours = '00';
  }
  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }
  return `${hours}:${minutes}:00`;
};

export const CombineDateAndTime = (date: any, time?: any) => {
  const newDate: any = new Date(date);
  const day: any = String(newDate?.getDate()).padStart(2, '0');
  const month: any = String(newDate.getMonth() + 1).padStart(2, '0');
  const year: any = String(newDate?.getFullYear());
  const time24hr: any = time;
  const finalDate = `${month}-${day}-${year} ${time24hr}`;
  return finalDate;
};

export const CombineDateAndTimeNew = (date: any, time?: any) => {
  const newDate: any = new Date(date);
  const day: any = String(newDate?.getDate()).padStart(2, '0');
  const month: any = String(newDate.getMonth() + 1).padStart(2, '0');
  const year: any = String(newDate?.getFullYear());
  const time24hr: any = time;
  const finalDate = `${month}/${day}/${year} ${time24hr}`;
  return finalDate;
};

export const CombineBlockDateAndTime = (
  date: any,
  time?: any,
  isFullDay?: any,
) => {
  const newDate: any = new Date(date);
  const day: any = String(newDate?.getDate()).padStart(2, '0');
  const month: any = String(newDate.getMonth() + 1).padStart(2, '0');
  const year: any = String(newDate?.getFullYear());
  const time24hr: any = time;
  const updateDate = `${month}-${day}-${year}`;
  const finalDate = `${month}-${day}-${year} ${time24hr}`;
  return isFullDay ? updateDate : finalDate;
};

export const autoSort = (option: any, key: any) => {
  const sortedList = option?.sort((a: any, b: any) =>
    a[key]?.toLowerCase() > b[key]?.toLowerCase()
      ? 1
      : b[key]?.toLowerCase() > a[key]?.toLowerCase()
      ? -1
      : 0,
  );
  return sortedList;
};

export const convertFrom24To12Format = (time24: any) => {
  const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
  const period = +sHours < 12 ? 'AM' : 'PM';
  const hours = +sHours % 12 || 12;

  return `${hours}:${minutes} ${period}`;
};
export const convertFrom24To12FormatOptHrs = (time24: any) => {
  const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
  const period = +sHours < 12 ? 'AM' : 'PM';
  const hours = +sHours % 12 || 12;
  return `${hours < 10 ? `0${hours}` : `${hours}`}:${minutes} ${period}`;
};
